const dataHandle = (
  params: any[]
): { viewData: string[]; requestData: string[] } => {
  const viewData: string[] = [],
    requestData: string[] = [];
  params.forEach((item: any) => {
    if (item?.typ === "builtin") {
      viewData.push(item);
      requestData.push(item);
    }
    if (item?.typ === "custom") {
      item.scope && requestData.push(item);
      item.idAndAction &&
        item.idAndAction.forEach((child: any) => {
          child.scope && requestData.push(child);
          if (child?.id === "*") {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            child?.actions &&
              child?.actions.forEach((element: any) => {
                if (element?.scope) {
                  const result = {
                    ...element,
                    scope: element.scope.split("*:").join(""),
                  };
                  requestData.push(result, element);
                }
              });
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            child?.actions &&
              child?.actions.forEach((element: any) => {
                element?.scope && requestData.push(element);
              });
          }
        });
    }
  });
  return { viewData, requestData };
};

export { dataHandle };
